import React from 'react';

import RolloverController from './RolloverController';
import PlayerRollover from './PlayerRollover';

export default class PlayerLink extends React.Component {
    constructor(props) {
        super(props);
        this.controller = new RolloverController(this, this.props.rolloverDirection || 'right', 300);
        this.state = this.controller.getInitialState();
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
    }

    _onMouseEnter() {
        this.controller.onMouseEnter(`/api/players/${this.props.pid}/brief`);
    }

    _onMouseLeave() {
        this.controller.onMouseLeave();
    }

    componentWillUnmount() {
        this.controller.componentWillUnmount();
    }

    render() {
        const href = `/players/${this.props.pid}`;
        let rollover;
        if (!this.props.norollover && this.state.rollover) {
            rollover = (
                <PlayerRollover
                    data={this.state.data}
                    onMouseEnter={this._onMouseEnter}
                    onMouseLeave={this._onMouseLeave}
                    directionInfo={this.controller.directionInfo}
                />
            );
        }
        let className = 'cc-player';
        const runs = this.props.runs;
        if (runs !== undefined) {
            if (runs >= 87) {
                className += ' cc-icon-after cc-icon-cup-87';
            } else if (runs >= 50) {
                className += ' cc-icon-after cc-icon-jug';
            }
        }
        const wickets = this.props.wickets;
        if (wickets !== undefined && wickets >= 5) {
            className += ' cc-icon-after cc-icon-jug';
        }
        const victims = this.props.victims;
        if (victims !== undefined && victims >= 3) {
            className += ' cc-icon-after cc-icon-jug';
        }
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        const fname = this.props.fname;
        const initial = fname.substring(0, 1);
        const rest = fname.substring(1);
        const link = (
            <a href={href} onMouseEnter={this._onMouseEnter} onMouseLeave={this._onMouseLeave}>
                {initial}
                {rest} {this.props.lname}
            </a>
        );
        if (this.controller.directionInfo && this.controller.directionInfo.direction === 'right') {
            return (
                <div ref="element" className={className}>
                    {link}
                    {rollover}
                </div>
            );
        }
        return (
            <div ref="element" className={className}>
                {rollover}
                {link}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PlayerLink.jsx